import LookupDropdown from "components/blocks/LookupDropdown";
import PaginatedLookupDropdown from "components/blocks/PaginatedLookupDropdown";
import { Control, Controller, FieldErrors, UseFormSetValue } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CreateOrderRequest, OrderLocalItemResult } from "services/orders/models/OrdersTypes";
import {ProgramByIDResponse, ProgramDetailsResult} from "../../../../../services/programs/models/ProgramTypes";

export default function LookupDropDowns({
    program,    
    details,
  control,
  errors,
  setValue,
  order,
  isInspectMode,
    isReadonly
}: {
    program?:  ProgramByIDResponse | null;
    details?:  ProgramDetailsResult | null;
  control: Control<CreateOrderRequest, any>;
  errors: FieldErrors<CreateOrderRequest>;
  setValue: UseFormSetValue<CreateOrderRequest>;
  order?: OrderLocalItemResult | null;
  isInspectMode?: boolean;
  isReadonly?: boolean;
}) {
  const { t } = useTranslation(["Orders", "Common"]);

  return (
    <div className="d-flex flex-column gap-3">
        { program==null && <Controller
        name="centreManagementId"
        control={control}
        render={({ field }) => (
          <PaginatedLookupDropdown
            wrapperClassName="flex-1 "
            label={t("researchesCenter")}
            labelClassName="fw-bold"
            queryKey="search"
            service="orderService"
            endpoint="getManagementCentersDropdown"
            textValueKey="centreManagementDetail.displayName"
            idValueKey="id"
            
            withAsterisk
            isPaginated
            error={errors.centreManagementId?.message}
            value={field.value}
            disabled={!!isInspectMode || isReadonly}
            defaultOptions={
              order
                ? [{ value: `${order.centreManagementId}`, label: order.centreManagementDetail?.displayName ?? "" }]
                : null
            }
            onChange={(value: string) => {
              setValue("centreManagementId", +value);
            }}
          />
        )}
      />}   
        { program && !program.isCentreManagementHidden && <Controller
        name="centreManagementId"
        control={control}
        render={({ field }) => (
          <PaginatedLookupDropdown
            wrapperClassName="flex-1 "
            label={details?.centreManagementLabel??t("researchesCenter")}
            labelClassName="fw-bold"
            queryKey="search"
            service="orderService"
            endpoint="getManagementCentersDropdown"
            textValueKey="centreManagementDetail.displayName"
            idValueKey="id"
            withAsterisk={program?.isCentreManagementRequired ?? true}
            isPaginated
            error={errors.centreManagementId?.message}
            value={field.value}
            disabled={!!isInspectMode || isReadonly}
            defaultOptions={
              order
                ? [{ value: `${order.centreManagementId}`, label: order.centreManagementDetail?.displayName ?? "" }]
                : null
            }
            onChange={(value: string) => {
              setValue("centreManagementId", +value);
            }}
          />
        )}
      />}
      <div className="d-flex gap-3 ">
          { program==null &&    <Controller
          name="researchFieldId"
          control={control}
          render={({ field }) => (
            <LookupDropdown
              wrapperClassName="flex-1 "
              labelClassName="fw-bold"
              label={t("researchField")}
              service="lookupService"
              withAsterisk
              endpoint="getAllResearchFields"
              textValueKey="researchFieldDetail.displayName"
              idValueKey="id"
              noSelectionPlaceholder={t("researchField")}
              error={errors.researchFieldId?.message}
              disabled={isReadonly}
              value={field.value}
              onChange={(value: string) => {
                setValue("researchFieldId", +value);
              }}
              enableSearch
              useReactSelect
            />
          )}
        />
          }  { program && !program.isResearchFieldHidden &&    <Controller
          name="researchFieldId"
          control={control}
          render={({ field }) => (
            <LookupDropdown
              wrapperClassName="flex-1 "
              labelClassName="fw-bold"
              label={t("researchField")}
              service="lookupService"
              withAsterisk={program?.isCentreManagementRequired ?? true}
              endpoint="getAllResearchFields"
              textValueKey="researchFieldDetail.displayName"
              idValueKey="id"
              noSelectionPlaceholder={t("researchField")}
              error={errors.researchFieldId?.message}
              value={field.value}
              disabled={isReadonly}
              onChange={(value: string) => {
                setValue("researchFieldId", +value);
              }}
              enableSearch
              useReactSelect
            />
          )}
        />
          }
          { program==null &&    <Controller
          name="subspecialty"
          control={control}
          render={({ field }) => (
            <PaginatedLookupDropdown
              isCreatable
              isPaginated={false}
              wrapperClassName="flex-1 "
              labelClassName="fw-bold"
              label={t("subspecialty")}
              queryKey="search"
              service="lookupService"
              endpoint="getAllSubSpecialties"
              textValueKey="subspecialtyDetails.displayName"
              idValueKey="id"
              value={field.value}
              disabled={isReadonly}
              error={errors.subspecialty?.message}
              defaultOptions={order ? [{ value: order.subspecialty, label: order.subspecialty }] : null}
              onChange={(_: string, item) => {
                setValue("subspecialty", item.value);
              }}
            />
          )}
        />} 
          
          { program && !program.isResearchFieldHidden &&    <Controller
          name="subspecialty"
          control={control}
          render={({ field }) => (
            <PaginatedLookupDropdown
              isCreatable
              isPaginated={false}
              wrapperClassName="flex-1 "
              labelClassName="fw-bold"
              label={t("subspecialty")}
              queryKey="search"
              service="lookupService"
              endpoint="getAllSubSpecialties"
              disabled={isReadonly}
              textValueKey="subspecialtyDetails.displayName"
              idValueKey="id"
              value={field.value}
              error={errors.subspecialty?.message}
              defaultOptions={order ? [{ value: order.subspecialty, label: order.subspecialty }] : null}
              onChange={(_: string, item) => {
                setValue("subspecialty", item.value);
              }}
            />
          )}
        />}
          
      </div>
    </div>
  );
}
